import NextLink from 'next/link'
import { twMerge } from 'tailwind-merge'

type LinkProps = {
  useColor?: boolean
} & React.ComponentPropsWithoutRef<typeof NextLink>

export default function Link({ useColor, className, children, ...props }: LinkProps) {
  className = twMerge(
    'transition duration-300 overflow-hidden dark:font-normal',
    useColor
      ? 'text-red-800 hover:text-red-600 dark:text-red-500 dark:hover:text-red-600'
      : 'text-zinc-900 hover:text-red-700 dark:text-zinc-300 hover:dark:text-red-500',
    className,
  )
  return (
    <NextLink className={className} {...props}>
      {children}
    </NextLink>
  )
}
